import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);
export default new Vuex.Store({
  state: {
    activeFolioId: false,
    folioOpen: false,
    folioFocused: false,
    detailsOpen: true,
    projects: [
      {
        id: 0,
        title: "Jobbatical",
        preview: "thumb-jobbatical.png",
        images: [
          {
            video: "matisse",
            desc: "Built and maintained Matisse (a React component library) from the ground up.",
          },
          {
            video: "dark-mode",
            desc: "Was able to get upgrade out base components to support dark-mode with little developer overhead.",
          },
          {
            video: "employer",
            desc: "A small guided tour of an older version of the platform.",
          },
          {
            image: "full-jobbatical-1.jpg",
            desc: "Created many complex screens in the platform as well as the API that supplies them.",
            align: "top",
          },
        ],
        description:
          "A platform that helps companies relocate talent across the world.",
        tech: [
          "React",
          "NextJS",
          "GraphQL",
          "Apollo",
          "MongoDB",
          "Express",
          "Node.js",
          "GCloud",
        ],
        note: "The reason I live in Spain.",
        //url: "https://jobbatical.com",
      },
      {
        id: 1,
        title: "Aether",
        preview: "thumb-aether.png",
        images: [
          {
            image: "full-aether-1.png",
            desc: "Party up with other players. Explore a tile-based world.",
            align: "top",
          },
          {
            image: "full-harpies-2.jpg",
            desc: "Maps are built with tiled and imported as JSON",
            align: "top",
          },
          {
            youtube:
              "https://www.youtube.com/embed/vvfUeE621Vk?rel=0&autoplay=1",
            desc: "Item system is fully functional. Enemies will spawn on the server. Moving feels natural on all devices",
            align: "top",
          },
        ],
        description:
          "A multiplayer role playing game written entirely in Javascript.",
        url: "https://aether.onrender.com",
        tech: [
          "React",
          "PhaserJS",
          "Node.js",
          "Socket.io",
          "MongoDB",
          "Express",
          "Photoshop",
        ],
        note: "My hobby ^^",
      },
      {
        id: 4,
        title: "React Highlight Menu",
        preview: "thumb-highlight.png",
        tech: ["Typescript", "React", "Vite", "Vitest"],
        note: "An open-source, un-opinionated medium.com style menu",
        description: "A context menu component.",
        url: "https://asyndesis.github.io/react-highlight-menu/",
      },
      {
        id: 2,
        title: "Fridge Poet",
        preview: "thumb-fridge-poet.jpg",
        images: [
          {
            image: "full-fridge-poet-1.jpg",
            desc: "Simple login using localstorage API",
            align: "top",
          },
          {
            image: "full-fridge-poet-2.jpg",
            desc: "Rooms can be created with various options. The slug is generated based on the room name.",
            align: "top",
          },
          {
            image: "full-fridge-poet-3.jpg",
            desc: "Words are randomly spawned based on selected poetry kits. Moving a word will update connected players through websockets.",
          },
        ],
        description: "A multiplayer magnetic poetry game.",
        tech: ["React", "Socket.io", "Express", "Node.js"],
        note: "Magnets, words and fridge-sockets",
        url: "https://fridge-poet.onrender.com",
      },
      {
        id: 5,
        title: "Interworx",
        preview: "thumb-interworx.jpg",
        images: [
          {
            image: "full-interworx-1.jpg",
            desc: "Homepage was redesigned and rebranded with purple as the new base color.",
            align: "top",
          },
          {
            image: "full-interworx-3.jpg",
            desc: "The feature page was built for customers to get a birds eye view.",
            align: "top",
          },
          {
            image: "full-interworx-2.jpg",
            desc: "The software itself now defaults to this purple theme out of the box.",
            align: "top",
          },
          {
            image: "full-interworx-5.jpg",
            desc: "View of Nodeworx on a phone or tablet.",
            align: "top",
            size: "contain",
          },
          {
            image: "full-interworx-4.jpg",
            desc: "CSS restyle of LATEX documentation.",
            align: "top",
          },
        ],
        description:
          "Redesign, rebuild and rebranding of website and software.",
        note: "Brought purple into their styleguide.",
        tech: ["wordpress", "scss", "photoshop"],
        //url: "https://web.archive.org/web/20180708032557/http://www.interworx.com/",
      },
      {
        id: 3,
        title: "Savviform JS",
        preview: "thumb-savviform.jpg",
        images: [
          {
            image: "full-savviform-1.jpg",
            desc: "View of form builder. Here is where a user can create a form.",
            align: "top",
          },
          {
            image: "full-savviform-2.jpg",
            desc: "View of the rendered form. A front end user can fill this form out and it will save their progress to localstorage.",
            align: "top",
          },
        ],
        description: "A dynamic formbuilder.",
        note: "Drag and drop fields to build a form.",
        tech: ["jQuery", "Bootstrap", "PHP", "wkhtmltopdf"],
        url: "http://trevorbonomi.com/savviform/render.html",
      },

      {
        id: 6,
        title: "Vector National Accounts",
        preview: "thumb-national-accounts.jpg",
        images: [
          {
            image: "full-na-1.jpg",
            desc: "The client dashboard was built so that widgets could be added, moved, edited or removed.",
            align: "top",
          },
          {
            image: "full-na-2.jpg",
            desc: "The call list interface was designed for clients to reset codes on the fly in bulk.",
            align: "top",
          },
          {
            image: "full-na-3.jpg",
            desc: "Various admin screens for controlling client widgets. (Note the cute little frozen icon)",
            align: "top",
          },
        ],
        tech: ["laravel", "PHP", "jquery", "bootstrap"],
        note: "Dashboards are kind of my jam.",
        description:
          "Design and code of security dashboard and various interfaces.",
      },
      {
        id: 7,
        title: "Medrespond",
        preview: "thumb-medrespond.jpg",
        images: [
          {
            image: "full-medrespond-1.jpg",
            desc: "Ask a question in the box and text analysis will provide the appropriate video response.",
            align: "top",
          },
          {
            image: "full-medrespond-2.jpg",
            desc: "Guided learning programs were used by thousands of applicants.",
            align: "top",
          },
          {
            image: "full-medrespond-3.jpg",
            desc: "The software supported various kinds of tests along the way inbetween and even below video segments.",
            align: "top",
          },
        ],
        tech: ["angular.js", "PHP", "jquery", "bootstrap", "codeigniter"],
        note: "Lots of videos. Lots of varied user input.",
        description: "Design and code of interactive video experiences.",
      },
      {
        id: 13,
        title: "Caregogi",
        preview: "thumb-caregogi.jpg",
        images: [
          {
            image: "full-caregogi-4.jpg",
            desc: "View of the careseeker dashboard.",
            align: "top",
          },
          {
            image: "full-caregogi-1.jpg",
            desc: "A careseeker can send schedule requests by booking caregivers to certain dates on this screen.",
          },
          {
            image: "full-caregogi-2.jpg",
            desc: "View of options when editing a shift.",
          },
          { image: "full-caregogi-3.jpg", desc: "The quick scheduler screen." },
        ],
        tech: ["jQuery", "PHP", "Bootstrap", "Laravel", "Fullcalendar"],
        note: "Feels like a small social network.",
        description: "A website that matches Caregivers with Careseekers.",
        //url: "http://www.caregogi.com",
      },
      // {
      //   hidden: true,
      //   secret: true,
      //   id: 14,
      //   title: "More items...",
      //   preview: "thumb-locks.png",
      //   note: "Contact me for details.",
      //   description: "Some company work excluded for privacy.",
      // },
    ],
  },
  mutations: {
    //var index = state.projects.find(item => item.id === payload);
    UPDATE_ACTIVE_FOLIO_ID: (state, payload) => {
      state.activeFolioId = payload;
    },
    UPDATE_FOLIO_OPEN: (state, payload) => {
      state.folioOpen = payload;
    },
    UPDATE_DETAILS_OPEN: (state, payload) => {
      state.detailsOpen = payload;
    },
    UPDATE_FOLIO_FOCUSED: (state, payload) => {
      state.folioFocused = payload;
    },
    SET_SECRET_PARAM: (state, value) => {
      state.secretParam = value;
    },
  },
  getters: {
    secretParam: (state) => state.secretParam,
    detailsOpen: (state) => state.detailsOpen,
    projects: (state) => state.projects,
    activeFolioId: (state) => state.activeFolioId,
    getFolioById: (state) => (id) => {
      let folio = state.projects.find((folio) => folio.id == id);
      if (folio !== undefined) {
        return folio;
      }
      return {
        id: false,
        title: "error",
        preview: "placeholder.jpg",
        images: [{ image: "placeholder.jpg", desc: "arf" }],
        description: "",
        url: "",
      };
    },
  },
  actions: {
    updateActiveFolioId: (context, payload) => {
      context.commit("UPDATE_ACTIVE_FOLIO_ID", payload);
    },
    updateFolioOpen: (context, payload) => {
      context.commit("UPDATE_FOLIO_OPEN", payload);
    },
    updateDetailsOpen: (context, payload) => {
      context.commit("UPDATE_DETAILS_OPEN", payload);
    },
    updateFocusedFolioId: (context, payload) => {
      context.commit("UPDATE_FOLIO_FOCUSED", payload);
    },
    setSecretParam: (context, value) => {
      context.commit("SET_SECRET_PARAM", value);
    },
  },
});
